export default [
  {
    text: 'Person',
    isPerson: true,
  },
  {
    text: 'Object',
    isPerson: false,
  },
];



// WEBPACK FOOTER //
// ./src/views/games/memory/personType.js